import invert from 'lodash/invert';
import snakeCase from 'lodash/snakeCase';

import LayoutCommonNew from "../../visComponents/layoutCommonNew";
import {LayoutType, LayoutAbbreviation} from "./constants";
import zIndexes from "./zIndex";
import Other from "./parts/other";
import NonVisualizerSubPart from "./subparts/nonVisualizerSubPart";
import DesignNavigationItem from "../../visComponents/designNavigationItem";
import Background from "./parts/background";
import Floor from "./parts/floor";
import Walls from "./parts/walls";
import {AVAILABLE_VISUALIZER_TYPES} from "../../../config";
import Globals from "./parts/globals";
import Cabinet from "./parts/cabinet";
import Accessories from "./parts/accessories";

export class LaundryRoomLayout extends LayoutCommonNew {

  /**
   * @type {int}
   */
  defaultType = LayoutType.Layout41;
  type = this.defaultType;
  scene = "1";
  visualizerType = AVAILABLE_VISUALIZER_TYPES.LaundryRoom;
  localStorageKey = "LaundryRoomState";
  layersBinding = "LaundryRoom";
  layoutNames = LayoutAbbreviation;
  layoutTypes = LayoutType;
  layoutThumbnails = {};
  zIndexes = zIndexes.layouts;
  excludedPartIdsFromHover = ["decor_", "background_bg", "walls_ceiling", "attachment"];

  constructor(props) {
    super(props);
    this.parts[Globals.id] = new Globals();
    this.parts[Background.id] = new Background();
    this.parts[Cabinet.id] = new Cabinet();
    this.parts[Walls.id] = new Walls();
    this.parts[Floor.id] = new Floor();
    this.parts[Accessories.id] = new Accessories();
    this.parts[Other.id] = new Other();
    Object.values(this.parts).forEach(part => part.layout = this);
  }

  getCurrentLayoutName(type = this.type) {
    return invert(LayoutType)[type];
  }

  getCurrentLayoutAbbreviation() {
    return LayoutAbbreviation[this.getCurrentLayoutName()]
  }

  addNonVisualizerSubPart(featureGroupName){
    const otherParent = this.parts[Other.id];
    const partId = snakeCase(featureGroupName);
    let relatedItem = otherParent.relatedItems.find(relatedItem => relatedItem.partId === partId);
    if (!relatedItem) {
      relatedItem = new NonVisualizerSubPart(true, partId, featureGroupName);
      relatedItem.getParent = () => otherParent;
      otherParent.relatedItems.push(relatedItem);
    }
    return new DesignNavigationItem(relatedItem.partName, relatedItem)
  }

}

export default new LaundryRoomLayout()
